import React from 'react';
import MetricaBase from './MetricaBase';

const MetricaFaixasEtarias = () => {
  return (
    <MetricaBase
      titulo="Distribuição por Faixas Etárias"
      descricao="Análise da distribuição de colaboradores ativos por idade"
      endpoint="faixas-etarias"
      tipoDownload="faixas-etarias"
      cor="green"
    />
  );
};

export default MetricaFaixasEtarias;